import {
  BACKGROUND_COLORS,
  BpkBox,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { useTranslation } from '../../helpers/hooks/useTranslation';
import AppErrorBoundary from '../AppErrorBoundary';

const MonthViewPageHeader = ({
  isMobilePhone = false,
}: {
  isMobilePhone?: boolean;
}) => {
  const translate = useTranslation();

  return (
    <AppErrorBoundary location="month-view-page-header">
      <BpkBox
        paddingTop={BpkSpacing.LG}
        paddingBottom={BpkSpacing.Base}
        paddingInline={isMobilePhone ? BpkSpacing.Base : BpkSpacing.None}
        backgroundColor={
          isMobilePhone ? BACKGROUND_COLORS.surfaceDefault : undefined
        }
        data-testid="month-view-page-header"
      >
        <BpkText
          textStyle={
            isMobilePhone ? TEXT_STYLES.heading3 : TEXT_STYLES.heading2
          }
          tagName="h1"
        >
          {translate('page_header_title_label')}
        </BpkText>
      </BpkBox>
    </AppErrorBoundary>
  );
};

export default MonthViewPageHeader;
